/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ReportDefs from './defs.defs.js'

const $nsid = 'tools.ozone.report.getLatestReport'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  report: /*#__PURE__*/ l.ref<ReportDefs.ReportView>(
    (() => ReportDefs.reportView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get the most recent report. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['NotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
